/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"/openapi/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ActiveEmployeeCreditCardDTO } from '../dto';
// @ts-ignore
import type { BulkCreateEmployeeCreditCardsDTO } from '../dto';
// @ts-ignore
import type { BulkCreateResponseDTO } from '../dto';
// @ts-ignore
import type { CreditCardChargeNotificationListDTO } from '../dto';
// @ts-ignore
import type { CreditCardTransactionsHistoryDTO } from '../dto';
// @ts-ignore
import type { EmployeeCreditCardBalanceHistoryDTO } from '../dto';
// @ts-ignore
import type { EmployeeCreditCardListDTO } from '../dto';
// @ts-ignore
import type { TenantCreditCardBudgetDTO } from '../dto';
// @ts-ignore
import type { UpdateCreditCardSettingsDTO } from '../dto';
// @ts-ignore
import type { ValidationErrorResponseDTO } from '../dto';
/**
 * CreditCardApi - axios parameter creator
 * @export
 */
export const CreditCardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary orders new credit cards for the selected employees of a tenant
         * @param {string} tenantId 
         * @param {BulkCreateEmployeeCreditCardsDTO} bulkCreateEmployeeCreditCardsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateCreditCards: async (tenantId: string, bulkCreateEmployeeCreditCardsDTO: BulkCreateEmployeeCreditCardsDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('bulkCreateCreditCards', 'tenantId', tenantId)
            // verify required parameter 'bulkCreateEmployeeCreditCardsDTO' is not null or undefined
            assertParamExists('bulkCreateCreditCards', 'bulkCreateEmployeeCreditCardsDTO', bulkCreateEmployeeCreditCardsDTO)
            const localVarPath = `/tenants/{tenantId}/benefits/creditCard/cards`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkCreateEmployeeCreditCardsDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary orders a new credit card for an employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCreditCard: async (tenantId: string, employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('createCreditCard', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('createCreditCard', 'employeeId', employeeId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/creditCard/cards`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GET active Card
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveCreditCard: async (tenantId: string, employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getActiveCreditCard', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getActiveCreditCard', 'employeeId', employeeId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/creditCard/cards/active`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GET credit card balances
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditCardBalances: async (tenantId: string, employeeId: string, cardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getCreditCardBalances', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getCreditCardBalances', 'employeeId', employeeId)
            // verify required parameter 'cardId' is not null or undefined
            assertParamExists('getCreditCardBalances', 'cardId', cardId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/creditCard/cards/{cardId}/balances`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"cardId"}}`, encodeURIComponent(String(cardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantBudget: async (tenantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getTenantBudget', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/creditCard/cards/budget`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [filter] 
         * @param {boolean} [withAggregations] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionHistory: async (tenantId: string, filter?: string, withAggregations?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getTransactionHistory', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/creditCard/cards/transactionHistory`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (withAggregations !== undefined) {
                localVarQueryParameter['withAggregations'] = withAggregations;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns all credit cards of a tenant
         * @param {string} tenantId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCreditCardChargeNotifications: async (tenantId: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('listCreditCardChargeNotifications', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/creditCard/chargeNotifications`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary returns all credit cards of a tenant
         * @param {string} tenantId 
         * @param {Array<ListCreditCardsStatusEnum>} [status] 
         * @param {string} [employeeId] 
         * @param {Array<string>} [employeeNumber] 
         * @param {string} [filter] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCreditCards: async (tenantId: string, status?: Array<ListCreditCardsStatusEnum>, employeeId?: string, employeeNumber?: Array<string>, filter?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('listCreditCards', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/creditCard/cards`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (employeeNumber) {
                localVarQueryParameter['employeeNumber'] = employeeNumber;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update the credit card company id of a tenant
         * @param {string} tenantId 
         * @param {UpdateCreditCardSettingsDTO} updateCreditCardSettingsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenantCreditCardSettings: async (tenantId: string, updateCreditCardSettingsDTO: UpdateCreditCardSettingsDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('updateTenantCreditCardSettings', 'tenantId', tenantId)
            // verify required parameter 'updateCreditCardSettingsDTO' is not null or undefined
            assertParamExists('updateTenantCreditCardSettings', 'updateCreditCardSettingsDTO', updateCreditCardSettingsDTO)
            const localVarPath = `/tenants/{tenantId}/benefits/creditCard/settings`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCreditCardSettingsDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CreditCardApi - functional programming interface
 * @export
 */
export const CreditCardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CreditCardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary orders new credit cards for the selected employees of a tenant
         * @param {string} tenantId 
         * @param {BulkCreateEmployeeCreditCardsDTO} bulkCreateEmployeeCreditCardsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkCreateCreditCards(tenantId: string, bulkCreateEmployeeCreditCardsDTO: BulkCreateEmployeeCreditCardsDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkCreateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkCreateCreditCards(tenantId, bulkCreateEmployeeCreditCardsDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditCardApi.bulkCreateCreditCards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary orders a new credit card for an employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCreditCard(tenantId: string, employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCreditCard(tenantId, employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditCardApi.createCreditCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary GET active Card
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveCreditCard(tenantId: string, employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveEmployeeCreditCardDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveCreditCard(tenantId, employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditCardApi.getActiveCreditCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary GET credit card balances
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} cardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCreditCardBalances(tenantId: string, employeeId: string, cardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeCreditCardBalanceHistoryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCreditCardBalances(tenantId, employeeId, cardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditCardApi.getCreditCardBalances']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTenantBudget(tenantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantCreditCardBudgetDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTenantBudget(tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditCardApi.getTenantBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [filter] 
         * @param {boolean} [withAggregations] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionHistory(tenantId: string, filter?: string, withAggregations?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreditCardTransactionsHistoryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionHistory(tenantId, filter, withAggregations, sortBy, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditCardApi.getTransactionHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns all credit cards of a tenant
         * @param {string} tenantId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCreditCardChargeNotifications(tenantId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreditCardChargeNotificationListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCreditCardChargeNotifications(tenantId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditCardApi.listCreditCardChargeNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary returns all credit cards of a tenant
         * @param {string} tenantId 
         * @param {Array<ListCreditCardsStatusEnum>} [status] 
         * @param {string} [employeeId] 
         * @param {Array<string>} [employeeNumber] 
         * @param {string} [filter] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCreditCards(tenantId: string, status?: Array<ListCreditCardsStatusEnum>, employeeId?: string, employeeNumber?: Array<string>, filter?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeCreditCardListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCreditCards(tenantId, status, employeeId, employeeNumber, filter, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditCardApi.listCreditCards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update the credit card company id of a tenant
         * @param {string} tenantId 
         * @param {UpdateCreditCardSettingsDTO} updateCreditCardSettingsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTenantCreditCardSettings(tenantId: string, updateCreditCardSettingsDTO: UpdateCreditCardSettingsDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTenantCreditCardSettings(tenantId, updateCreditCardSettingsDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreditCardApi.updateTenantCreditCardSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CreditCardApi - factory interface
 * @export
 */
export const CreditCardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CreditCardApiFp(configuration)
    return {
        /**
         * 
         * @summary orders new credit cards for the selected employees of a tenant
         * @param {CreditCardApiBulkCreateCreditCardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateCreditCards(requestParameters: CreditCardApiBulkCreateCreditCardsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkCreateResponseDTO> {
            return localVarFp.bulkCreateCreditCards(requestParameters.tenantId, requestParameters.bulkCreateEmployeeCreditCardsDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary orders a new credit card for an employee
         * @param {CreditCardApiCreateCreditCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCreditCard(requestParameters: CreditCardApiCreateCreditCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createCreditCard(requestParameters.tenantId, requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GET active Card
         * @param {CreditCardApiGetActiveCreditCardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveCreditCard(requestParameters: CreditCardApiGetActiveCreditCardRequest, options?: RawAxiosRequestConfig): AxiosPromise<ActiveEmployeeCreditCardDTO> {
            return localVarFp.getActiveCreditCard(requestParameters.tenantId, requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GET credit card balances
         * @param {CreditCardApiGetCreditCardBalancesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditCardBalances(requestParameters: CreditCardApiGetCreditCardBalancesRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeCreditCardBalanceHistoryDTO> {
            return localVarFp.getCreditCardBalances(requestParameters.tenantId, requestParameters.employeeId, requestParameters.cardId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreditCardApiGetTenantBudgetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantBudget(requestParameters: CreditCardApiGetTenantBudgetRequest, options?: RawAxiosRequestConfig): AxiosPromise<TenantCreditCardBudgetDTO> {
            return localVarFp.getTenantBudget(requestParameters.tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreditCardApiGetTransactionHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionHistory(requestParameters: CreditCardApiGetTransactionHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreditCardTransactionsHistoryDTO> {
            return localVarFp.getTransactionHistory(requestParameters.tenantId, requestParameters.filter, requestParameters.withAggregations, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns all credit cards of a tenant
         * @param {CreditCardApiListCreditCardChargeNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCreditCardChargeNotifications(requestParameters: CreditCardApiListCreditCardChargeNotificationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreditCardChargeNotificationListDTO> {
            return localVarFp.listCreditCardChargeNotifications(requestParameters.tenantId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary returns all credit cards of a tenant
         * @param {CreditCardApiListCreditCardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCreditCards(requestParameters: CreditCardApiListCreditCardsRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeCreditCardListDTO> {
            return localVarFp.listCreditCards(requestParameters.tenantId, requestParameters.status, requestParameters.employeeId, requestParameters.employeeNumber, requestParameters.filter, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update the credit card company id of a tenant
         * @param {CreditCardApiUpdateTenantCreditCardSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenantCreditCardSettings(requestParameters: CreditCardApiUpdateTenantCreditCardSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateTenantCreditCardSettings(requestParameters.tenantId, requestParameters.updateCreditCardSettingsDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bulkCreateCreditCards operation in CreditCardApi.
 * @export
 * @interface CreditCardApiBulkCreateCreditCardsRequest
 */
export interface CreditCardApiBulkCreateCreditCardsRequest {
    /**
     * 
     * @type {string}
     * @memberof CreditCardApiBulkCreateCreditCards
     */
    readonly tenantId: string

    /**
     * 
     * @type {BulkCreateEmployeeCreditCardsDTO}
     * @memberof CreditCardApiBulkCreateCreditCards
     */
    readonly bulkCreateEmployeeCreditCardsDTO: BulkCreateEmployeeCreditCardsDTO
}

/**
 * Request parameters for createCreditCard operation in CreditCardApi.
 * @export
 * @interface CreditCardApiCreateCreditCardRequest
 */
export interface CreditCardApiCreateCreditCardRequest {
    /**
     * 
     * @type {string}
     * @memberof CreditCardApiCreateCreditCard
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CreditCardApiCreateCreditCard
     */
    readonly employeeId: string
}

/**
 * Request parameters for getActiveCreditCard operation in CreditCardApi.
 * @export
 * @interface CreditCardApiGetActiveCreditCardRequest
 */
export interface CreditCardApiGetActiveCreditCardRequest {
    /**
     * 
     * @type {string}
     * @memberof CreditCardApiGetActiveCreditCard
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CreditCardApiGetActiveCreditCard
     */
    readonly employeeId: string
}

/**
 * Request parameters for getCreditCardBalances operation in CreditCardApi.
 * @export
 * @interface CreditCardApiGetCreditCardBalancesRequest
 */
export interface CreditCardApiGetCreditCardBalancesRequest {
    /**
     * 
     * @type {string}
     * @memberof CreditCardApiGetCreditCardBalances
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CreditCardApiGetCreditCardBalances
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof CreditCardApiGetCreditCardBalances
     */
    readonly cardId: string
}

/**
 * Request parameters for getTenantBudget operation in CreditCardApi.
 * @export
 * @interface CreditCardApiGetTenantBudgetRequest
 */
export interface CreditCardApiGetTenantBudgetRequest {
    /**
     * 
     * @type {string}
     * @memberof CreditCardApiGetTenantBudget
     */
    readonly tenantId: string
}

/**
 * Request parameters for getTransactionHistory operation in CreditCardApi.
 * @export
 * @interface CreditCardApiGetTransactionHistoryRequest
 */
export interface CreditCardApiGetTransactionHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof CreditCardApiGetTransactionHistory
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof CreditCardApiGetTransactionHistory
     */
    readonly filter?: string

    /**
     * 
     * @type {boolean}
     * @memberof CreditCardApiGetTransactionHistory
     */
    readonly withAggregations?: boolean

    /**
     * 
     * @type {Array<string>}
     * @memberof CreditCardApiGetTransactionHistory
     */
    readonly sortBy?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof CreditCardApiGetTransactionHistory
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CreditCardApiGetTransactionHistory
     */
    readonly pageSize?: number
}

/**
 * Request parameters for listCreditCardChargeNotifications operation in CreditCardApi.
 * @export
 * @interface CreditCardApiListCreditCardChargeNotificationsRequest
 */
export interface CreditCardApiListCreditCardChargeNotificationsRequest {
    /**
     * 
     * @type {string}
     * @memberof CreditCardApiListCreditCardChargeNotifications
     */
    readonly tenantId: string

    /**
     * 
     * @type {number}
     * @memberof CreditCardApiListCreditCardChargeNotifications
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CreditCardApiListCreditCardChargeNotifications
     */
    readonly pageSize?: number
}

/**
 * Request parameters for listCreditCards operation in CreditCardApi.
 * @export
 * @interface CreditCardApiListCreditCardsRequest
 */
export interface CreditCardApiListCreditCardsRequest {
    /**
     * 
     * @type {string}
     * @memberof CreditCardApiListCreditCards
     */
    readonly tenantId: string

    /**
     * 
     * @type {Array<'PENDING' | 'ORDERED' | 'ERROR' | 'ACTIVE' | 'EXPIRED'>}
     * @memberof CreditCardApiListCreditCards
     */
    readonly status?: Array<ListCreditCardsStatusEnum>

    /**
     * 
     * @type {string}
     * @memberof CreditCardApiListCreditCards
     */
    readonly employeeId?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof CreditCardApiListCreditCards
     */
    readonly employeeNumber?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof CreditCardApiListCreditCards
     */
    readonly filter?: string

    /**
     * 
     * @type {number}
     * @memberof CreditCardApiListCreditCards
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CreditCardApiListCreditCards
     */
    readonly pageSize?: number
}

/**
 * Request parameters for updateTenantCreditCardSettings operation in CreditCardApi.
 * @export
 * @interface CreditCardApiUpdateTenantCreditCardSettingsRequest
 */
export interface CreditCardApiUpdateTenantCreditCardSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof CreditCardApiUpdateTenantCreditCardSettings
     */
    readonly tenantId: string

    /**
     * 
     * @type {UpdateCreditCardSettingsDTO}
     * @memberof CreditCardApiUpdateTenantCreditCardSettings
     */
    readonly updateCreditCardSettingsDTO: UpdateCreditCardSettingsDTO
}

/**
 * CreditCardApi - object-oriented interface
 * @export
 * @class CreditCardApi
 * @extends {BaseAPI}
 */
export class CreditCardApi extends BaseAPI {
    /**
     * 
     * @summary orders new credit cards for the selected employees of a tenant
     * @param {CreditCardApiBulkCreateCreditCardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditCardApi
     */
    public bulkCreateCreditCards(requestParameters: CreditCardApiBulkCreateCreditCardsRequest, options?: RawAxiosRequestConfig) {
        return CreditCardApiFp(this.configuration).bulkCreateCreditCards(requestParameters.tenantId, requestParameters.bulkCreateEmployeeCreditCardsDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary orders a new credit card for an employee
     * @param {CreditCardApiCreateCreditCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditCardApi
     */
    public createCreditCard(requestParameters: CreditCardApiCreateCreditCardRequest, options?: RawAxiosRequestConfig) {
        return CreditCardApiFp(this.configuration).createCreditCard(requestParameters.tenantId, requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GET active Card
     * @param {CreditCardApiGetActiveCreditCardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditCardApi
     */
    public getActiveCreditCard(requestParameters: CreditCardApiGetActiveCreditCardRequest, options?: RawAxiosRequestConfig) {
        return CreditCardApiFp(this.configuration).getActiveCreditCard(requestParameters.tenantId, requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GET credit card balances
     * @param {CreditCardApiGetCreditCardBalancesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditCardApi
     */
    public getCreditCardBalances(requestParameters: CreditCardApiGetCreditCardBalancesRequest, options?: RawAxiosRequestConfig) {
        return CreditCardApiFp(this.configuration).getCreditCardBalances(requestParameters.tenantId, requestParameters.employeeId, requestParameters.cardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreditCardApiGetTenantBudgetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditCardApi
     */
    public getTenantBudget(requestParameters: CreditCardApiGetTenantBudgetRequest, options?: RawAxiosRequestConfig) {
        return CreditCardApiFp(this.configuration).getTenantBudget(requestParameters.tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreditCardApiGetTransactionHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditCardApi
     */
    public getTransactionHistory(requestParameters: CreditCardApiGetTransactionHistoryRequest, options?: RawAxiosRequestConfig) {
        return CreditCardApiFp(this.configuration).getTransactionHistory(requestParameters.tenantId, requestParameters.filter, requestParameters.withAggregations, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns all credit cards of a tenant
     * @param {CreditCardApiListCreditCardChargeNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditCardApi
     */
    public listCreditCardChargeNotifications(requestParameters: CreditCardApiListCreditCardChargeNotificationsRequest, options?: RawAxiosRequestConfig) {
        return CreditCardApiFp(this.configuration).listCreditCardChargeNotifications(requestParameters.tenantId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary returns all credit cards of a tenant
     * @param {CreditCardApiListCreditCardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditCardApi
     */
    public listCreditCards(requestParameters: CreditCardApiListCreditCardsRequest, options?: RawAxiosRequestConfig) {
        return CreditCardApiFp(this.configuration).listCreditCards(requestParameters.tenantId, requestParameters.status, requestParameters.employeeId, requestParameters.employeeNumber, requestParameters.filter, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update the credit card company id of a tenant
     * @param {CreditCardApiUpdateTenantCreditCardSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditCardApi
     */
    public updateTenantCreditCardSettings(requestParameters: CreditCardApiUpdateTenantCreditCardSettingsRequest, options?: RawAxiosRequestConfig) {
        return CreditCardApiFp(this.configuration).updateTenantCreditCardSettings(requestParameters.tenantId, requestParameters.updateCreditCardSettingsDTO, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListCreditCardsStatusEnum = {
    Pending: 'PENDING',
    Ordered: 'ORDERED',
    Error: 'ERROR',
    Active: 'ACTIVE',
    Expired: 'EXPIRED'
} as const;
export type ListCreditCardsStatusEnum = typeof ListCreditCardsStatusEnum[keyof typeof ListCreditCardsStatusEnum];
